module.exports = "<div class=\"form-group datepicker-wrapper\">\n  <form class=\"date-form\">\n    <input class=\"form-control\" #dateInput (blur)=\"update()\">\n  </form>\n  <i class=\"oi oi-calendar cal\" (click)=\"dateInput.focus()\"></i>\n  <i class=\"oi oi-clock clock\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/date-time-picker/date-time-picker.component.html
// module id = ../../../../../src/app/shared/components/date-time-picker/date-time-picker.component.html
// module chunks = 12